<template>
    <o-table :title="$t('sandoz_sortalys.assortment_analysis')" ref="tableList"
             url="/api/sandoz/assortment_analysis" :enable-edit="false" :enable-delete="false"
             default-sort-by-direction="desc">
        <template slot="filter">
        </template>
        <template slot="head">
            <o-table-header column="title">{{ $t('sandoz_sortalys.title') }}</o-table-header>
            <o-table-header column="status">{{ $t('sandoz_sortalys.status') }}</o-table-header>
            <o-table-header column="total_rows">{{ $t('sandoz_sortalys.total_rows') }}</o-table-header>
            <o-table-header column="total_assortment_analysis">{{ $t('sandoz_sortalys.total_heads') }}</o-table-header>
            <o-table-header column="created_at">{{ $t('sandoz_sortalys.analysis_date') }}</o-table-header>
            <o-table-header column="created_at">{{ $t('sandoz_sortalys.rep_visibility') }}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.title }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.total_rows }}</td>
            <td>{{ props.item.total_assortment_analysis }}</td>
            <td>{{ props.item.created_at | formatDate }}</td>
            <td>
                <div v-if="props.item.visible" class="badge badge-success cursor-pointer"
                     :class="{'btn-loading': visibilityChanging == props.item.id}"
                     @click="changeVisbility(props.item, false)">{{ $t('sandoz.yes') }}
                </div>
                <div v-if="!props.item.visible" class="badge badge-secondary cursor-pointer"
                     :class="{'btn-loading': visibilityChanging == props.item.id}"
                     @click="changeVisbility(props.item, true)">{{ $t('sandoz.no') }}
                </div>
            </td>
        </template>
        <template slot="body-controls" slot-scope="props">
            <td class="text-right">
                <router-link :to="{ path: $route.path + '/' + props.item.direct_link_id + '/standalone' }"
                             class="btn btn-primary" target="_blank">
                    <fa icon="eye"/>
                </router-link>
                <b-btn variant="primary" @click.prevent="downloadExcel(props.item.id)">
                    <fa icon="download"/>
                </b-btn>
                <router-link :to="{ path: $route.path + '/' + props.item.id + '/pivot' }" class="btn btn-primary">
                    <fa icon="arrow-right"/>
                </router-link>
            </td>
        </template>
    </o-table>
</template>


<script>
import axios from 'axios'

export default {
    data: () => ({
        visibilityChanging: 0
    }),
    mounted() {
    },
    methods: {
        changeVisbility(record, visible) {
            this.visibilityChanging = record.id

            var url = '/api/sandoz/assortment_analysis/' + record.id
            var params = {visible: visible}
            axios.post(url, params)
                .then((response) => {
                    this.visibilityChanging = 0
                    record.visible = visible
                })
                .catch((error) => {
                    this.$notify({
                        title: this.$i18n.t('core.load_error'),
                        text: this.$i18n.t('core.load_error_text', {url: url}),
                        type: 'error'
                    })
                })
        },
        downloadExcel(id) {
            axios.get('/api/sandoz/assortment_analysis/' + id + '/excel', {"responseType": 'arraybuffer'})
                .then((response) => {
                    require('downloadjs')(response.data,
                        'analysis_' + id + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    )
                }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>
